import React from "react";
import RegistrationView from "./RegistrationView";

/**
 * View für die Registrierung eines Benutzers
 * @returns {JSX.Element}
 * @constructor
 */
function EmbeddedRegistrationView(props) {
    return (
        <div className={"white_background"}>
            <RegistrationView
                {...props}
            />
        </div>
    );
}

export default EmbeddedRegistrationView;
